import { createContext } from "react";

export const MobileContext = createContext(false);